import { createAction } from 'redux-actions';
import { DIRECT_REPLY_RECEIVED } from '../constants/actionTypes';
export const directReplyReceived = createAction(DIRECT_REPLY_RECEIVED, ({
  newDirectReplies,
  threadId
}) => ({
  newDirectReplies,
  threadId
}));